const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
export const API_URL = import.meta.env.VITE_API_BASE_URL
  || (!hostname || hostname === 'localhost' ? '/api/v1' : `https://${hostname}/api/v1`);

